// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {ReactNode, useCallback} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {use_qs} from './use_qs';

interface i_trans_v_props {
    i18nKey?: string;
    defaults?: string;
    children?: ReactNode;
    components?: readonly React.ReactNode[] |
        { readonly [tagName: string]: React.ReactNode }
    values?: any;
    ns?: string;
    t?: any;
}

const Trans_v = (props: i_trans_v_props)=>{
    const {t, children, ...rest} = props;
    const def_key = (props.i18nKey || typeof children == 'string' && children
        || '').trim() || undefined;
    const defaults = props.defaults || t(def_key, {ns: 'translation',
        replace: props.values});
    return <Trans {...rest} defaults={defaults}>{children}</Trans>;
};

interface i_use_translation_v_props {
    version?: string | number;
    no_defaults?: boolean;
}

export const use_translation_v = (props?: i_use_translation_v_props)=>{
    const qs = use_qs();
    const ns = `${props?.version || qs.version || 'translation'}`;
    // XXX dmitriiz: update i18next, react-i18next for removing type-fix
    const {t} = useTranslation(ns) as {t: any};
    const T = useCallback((p: Exclude<i_trans_v_props, 'ns' | 't'>)=>{
        const T_cmp = props?.no_defaults ? Trans : Trans_v;
        return <T_cmp {...p} ns={ns} t={t}/>;
    }, [t, props, ns]);
    return {t, T};
};
